/**
 * Comparator function to sort items by their order field in ascending order.
 * Treats undefined, null, NaN, and Infinity, and floating point numbers as 0.
 */
export const sortOrderAscending = (
  a: { order?: number },
  b: { order?: number }
): number => {
  const getValidOrder = (order: number | undefined | null): number => {
    const value = order ?? 0;
    return Number.isInteger(value) ? value : 0;
  };

  const numA = getValidOrder(a.order);
  const numB = getValidOrder(b.order);
  return numA - numB;
};
